<script lang="ts">
    import TemplateIcon from './TemplateIcon.svelte';
    import src from './svg/official/Rapid.svg';

    export let scale: number = 1;
    export let title: string = '';
    export let spin: boolean = false;
</script>

<TemplateIcon {src} hover={title} {scale} on:click {spin} />
